import instance from "./request";

// 获取验证码
export function getCode(value:any) {
    return instance.post('/user/sendSms', value);
}
// 绑定手机
export function Login(value:any) {
    return instance.post('/user/bindPhone',
        value
    );
}
// 绑定邮箱
export function bindEmail(value:any) {
    return instance.post('/user/bindEmail',
        value
    );
}
// 邮箱发送验证码
export function sendEmailCode(value:any) {
    return instance.post('/user/sendEmailCode',
        value
    );
}

//账号登录
export function accountLogin(value:any) {
    return instance.post('user/login', value);
}

//跳转
export function test(value:any) {
    return instance.post('/game/forward/test2',value);
}

//修改用户名称
export function changeName(value:any) {
    return instance.post('/user/updateAppUserNick',value);
}

//修改用户名称
export function changeIcon(value:any) {
    return instance.post('/user/updateAppUserHead',value);
}

//上报事件
export function reportEvent(value:any) {
    return instance.post('/user/eventUploadResult',value);
}


//重置密码
export function resetPassword(value:any) {
    return instance.post('/user/resetPassword',value);
}

//用户数据打点
export function userDataSend(value:any) {
    return instance.post('/dataMark/saveLog',value);
}

//用户数据打点
export function appVisit(value:any) {
    return instance.post('/dataMark/appVisit',value);
}

//数据打点
export function cookieStr(value:any) {
    return instance.post('/dataMark/cookieStr',value);
}

//用户银行卡信息
export function userBankInfo(value:any) {
    return instance.post('/user/getUserBankInfo',value);
}
//用户切换语言显示
export function usersetLang(value:any) {
    return instance.post('/user/setLang',value);
}

//账号绑定
export function bindAccount(value:any) {
    return instance.post('user/bindAccount',
        value
    );
}
//获取上报充值记录
export function getFbRechargeRecords(value:any) {
    return instance.post('/user/getFbRechargeRecords',
        value
    );
}
//获取充值记录上报完成后，告诉上报结果
export function updateFbRechargeRecords(value:any) {
    return instance.post('/user/updateFbRechargeRecords',
        value
    );
}
//获取fbEventInitId
export function getFbEventId(value:any) {
    return instance.post('/user/getFbEventId',
        value
    );
}
//获取apk下载奖励接口
export function getDownloadApkReward(value:any) {
    return instance.post('/user/getDownloadApkReward',
        value
    );
}
//获取apk访问域名
export function getFlutterUrl(value:any) {
    return instance.post('/user/getFlutterUrl',
        value
    );
}

/**下载apk数据打点 */
export function markApkClick(value: any) {
    return instance.post('/user/markApkClick',
        value
    );
}

/**获取首充奖励信息 */
export function getFirstChargeRewardInfo(value: any) {
    return instance.post('/user/getFirstChargeRewardInfo',
        value
    );
}

/**领取首充奖励 */
export function getFirstChargeReward(value: any) {
    return instance.post('/user/getFirstChargeReward',
        value
    );
}

/**发送fb信息 */
export function updateFbpAndFbc(value: any) {
    return instance.post('/user/updateFbpAndFbc',
        value
    );
}